// src/features/merchantConfig/components/editors/StringEditor.jsx
//
// Single-line text editor for short string values. Commits on blur (typical
// form pattern) and clears the local input state if the user presses Esc
// before committing.

import React, { useEffect, useState } from "react";
import { inputClass } from "./editorChrome";

/**
 * @param {{
 *   value: string,
 *   onCommit: (next: string) => void,
 *   ariaLabel: string,
 *   hasError?: boolean,
 *   placeholder?: string,
 *   inputId?: string,
 * }} props
 */
export default function StringEditor({
  value,
  onCommit,
  ariaLabel,
  hasError,
  placeholder,
  inputId,
}) {
  const [draft, setDraft] = useState(value ?? "");

  // Re-sync if parent rewrites the value (e.g. after cancel / save).
  useEffect(() => {
    setDraft(value ?? "");
  }, [value]);

  const commitIfChanged = () => {
    if (draft !== (value ?? "")) {
      onCommit(draft);
    }
  };

  return (
    <input
      id={inputId}
      type="text"
      value={draft}
      placeholder={placeholder}
      aria-label={ariaLabel}
      aria-invalid={hasError || undefined}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commitIfChanged}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          commitIfChanged();
          e.currentTarget.blur();
        } else if (e.key === "Escape") {
          e.preventDefault();
          setDraft(value ?? "");
          e.currentTarget.blur();
        }
      }}
      className={inputClass({ hasError })}
    />
  );
}
